import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.to-string.js";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (g && (g = 0, op[0] && (_ = 0)), _) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
/*
 * @Author       : Zhelin Cheng
 * @Date         : 2021-04-22 19:34:05
 * @LastEditors: 邓鹏
 * @LastEditTime: 2026-08-04 10:59:21
 * @FilePath: /marketing-landing-fe/src/pages/landing/index.ts
 * @Description  : 未添加文件描述
 */


import './index.less';
import jojoAccount from '@jojo/account-sdk';
import storage from '@woulsl/storage';
import Cookie from 'js-cookie'; // import { uploadTraceLog } from '@/helpers/trace';

import lazySizes from 'lazysizes';
import { APP_ROUTE_INDEX_MAP, INDEX_URL, PACKAGE_NAME, PLACEHOLDER_MAP } from '@/const';
import bottomButton from '@/modules/landing/BottomButton';
import BottomButtonGroup from '@/modules/landing/BottomButtonGroup';
import { aliPreparePay } from '@/modules/landing/CourseSelection/methods/pay';
import customerServiceButton from '@/modules/landing/CustomerServiceButton';
import Toast from '@/plugins/Toast'; // import { appendPrompt } from '@/plugins/Prompt';

import { buriedSetCookie, getApolloKey, getCampaignShow, getCurrentIpAddress, getQuestionConfig, getWxConfig, listPopConfig, pointReportMsg, tiktokVerify, userActionRecord } from '@/services/landing';
import { checkUrl, connectLink, getCurrPlatform, isJoJoAllBrowser, isJoJoBrowser, isJoJoReadBrowser, isTikTok, isWXAppBrowser, isWXBrowser, qsParse, reportError, setSubDomainCookies } from '@/utils';
import { canJsonParse } from '@/utils';
import bridge, { appShareH5Config, canUseBridge, hasAppApi, interceptReadAppEvaluationBack, jumpAppRoute } from '@/utils/bridge';
import { addClass, removeClass, stringToDom } from '@/utils/dom'; // import VideoModule from '@/modules/landing/VideoModule';

import bus from '@/utils/eventemitter';
import { preloadHeroImage } from '@/utils/heroImage';
import { replaceStateInMiniApp } from '@/utils/miniAppShare';
import * as sdkLoader from '@/utils/sdkLoader';
import { Exposure, exposureModule, saveAbTestSensData, saveSensData, sensAutoTrack, sensClickInitiative, sensElementView } from '@/utils/sensors';
import Pageleave from '@/utils/sensorsPlugin/pageLeave';
import { handleAuth } from '@/utils/toAuthorize';
import { initTsecTuring } from '@/utils/tsecTuring';
var uid = Cookie.get('uid');
var isWeChat = isWXBrowser();
var isJoJoApp = isJoJoBrowser();
var isJoJoReadApp = isJoJoReadBrowser();
sdkLoader.initEagerLoad(); // 懒加载配置

lazySizes.cfg.expand = 100; // const PAGE_ID = 'marketingPutOnIndex';

/*
组件类型： 1图片，2跑马灯，3选课组件，4倒计时，5按钮，7参团组件，8Tab组件，9用户评价，10问大家好，11视频组件，16客服入口组件，17推荐人信息组件
组件子类型：4.1时间倒计时，4.2剩余名额，5.1默认按钮，5.2图片按钮，5.3参团按钮
*/

var modulesMap = {
  2: 'PhoneNumber',
  3: 'CourseSelection',
  4: 'CountdownTime',
  7: 'ParticipateGroup',
  8: 'TabPanel',
  9: 'UserEvaluation',
  10: 'AskEveryone',
  11: 'VideoModule',
  12: 'JoinFansButton',
  13: 'SwiperTemplate',
  14: 'ProductName',
  15: 'LoginModule',
  17: 'ReferrerInfo',
  999: 'AnswerQuestion'
};
var query = qsParse();

var doIntercept = function doIntercept(intercepted, callBack) {
  return __awaiter(void 0, void 0, void 0, function () {
    var hasInterceptGoBackAction, error_1;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 2,, 3]);

          return [4
          /*yield*/
          , hasAppApi('interceptAutoGoBackAction')];

        case 1:
          hasInterceptGoBackAction = _a.sent();

          if (hasInterceptGoBackAction) {
            bridge.call('interceptAutoGoBackAction', {
              intercepted: intercepted
            }, function (res) {
              console.log("intercept".concat(intercepted, "===="), res);

              if (typeof callBack === 'function') {
                callBack();
              }
            });
          }

          return [3
          /*break*/
          , 3];

        case 2:
          error_1 = _a.sent();
          console.log(error_1);
          return [3
          /*break*/
          , 3];

        case 3:
          return [2
          /*return*/
          ];
      }
    });
  });
};

var AppCalljsGoBackFn = function AppCalljsGoBackFn(config, _a) {
  var _b;

  var bizId = _a.bizId,
      campaignId = _a.campaignId;
  var button = config.button,
      imageUrl = config.imageUrl,
      jumpUrl = config.jumpUrl;
  var $content = document.getElementById('j-wp-ct-retain');
  var $img = document.getElementById('j-wp-ct-retain-img');
  var url_id = (query === null || query === void 0 ? void 0 : query.linkId) || '';
  var activity_id = campaignId;
  $img.src = imageUrl;

  if ($content) {
    var $btn1 = $content.querySelector('.j-wp-ct-retain-btn-1');
    var $btn2 = $content.querySelector('.j-wp-ct-retain-btn-2');
    $btn2.innerText = button;
    $btn1.addEventListener('click', function () {
      doIntercept('false', function () {
        sensClickInitiative({
          $element_name: '坚决退出',
          material_position: '挽留弹窗',
          url_id: url_id,
          activity_id: activity_id
        });
        bridge.call('H5closeWebController', {}, function () {});
      });
    });
    $btn2.addEventListener('click', function () {
      sensClickInitiative({
        $element_name: button,
        material_position: '挽留弹窗',
        url_id: url_id,
        activity_id: activity_id
      });
      doIntercept('false');
      bridge.off('appCalljs_autoGoBackFn', function () {
        return {
          goBack: true
        };
      });
      $content.style.display = 'none';
      window.location.href = jumpUrl;
    });
    $content.style.display = 'flex';
    sensElementView({
      c_element_name: '挽留弹窗',
      url_id: url_id,
      activity_id: activity_id
    });
    (_b = $content.querySelector('.wp-close')) === null || _b === void 0 ? void 0 : _b.addEventListener('click', function () {
      $content.style.display = 'none';
      sensClickInitiative({
        $element_name: '关闭按钮',
        material_position: '挽留弹窗',
        url_id: url_id,
        activity_id: activity_id
      });
      doIntercept('false');
    });
    var key = "landing_retain_".concat(bizId);
    var now = new Date();
    var endOfDay = new Date();
    endOfDay.setHours(23, 59, 59, 999);
    var timeDiff = endOfDay.getTime() - now.getTime();
    storage.set(key, '1', timeDiff);
  }
};

export var fn = {
  ele: {
    $root: document.getElementById('root')
  },
  // 获取默认areaCode
  getDefaultAreaCode: function getDefaultAreaCode() {
    return __awaiter(this, void 0, void 0, function () {
      var fr, _a, areaCodeResp, _b, resultCode, data_1, areaCodes, res, res2, _c;

      return __generator(this, function (_d) {
        switch (_d.label) {
          case 0:
            fr = query.fr || '';

            if (fr === 'bg') {
              return [2
              /*return*/
              , '+86'];
            }

            _d.label = 1;

          case 1:
            _d.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , Promise.all([jojoAccount.getNationalCodeList(), getCurrentIpAddress()])];

          case 2:
            _a = _d.sent(), areaCodeResp = _a[0], _b = _a[1], resultCode = _b.resultCode, data_1 = _b.data;
            areaCodes = (areaCodeResp === null || areaCodeResp === void 0 ? void 0 : areaCodeResp.data) || [];

            if (resultCode === 200 && data_1) {
              // 合并中国澳门/中国香港等场景 （country=中国，region=香港）
              if (data_1.country === '中国') {
                // 存储region
                __store.region = data_1.region;

                if (['香港', '澳门', '台湾'].includes(data_1.region || '')) {
                  res = areaCodes.find(function (el) {
                    return "".concat(data_1.country).concat(data_1.region) === el.nationalName;
                  });
                  return [2
                  /*return*/
                  , "+".concat(res.nationalCode)];
                }

                return [2
                /*return*/
                , '+86'];
              }

              res2 = areaCodes.find(function (el) {
                return el.nationalName === data_1.country;
              });
              return [2
              /*return*/
              , "+".concat(res2.nationalCode)];
            }

            return [3
            /*break*/
            , 4];

          case 3:
            _c = _d.sent();
            return [3
            /*break*/
            , 4];

          case 4:
            return [2
            /*return*/
            , '+86'];
        }
      });
    });
  },
  // 营销链路2.0测试
  linkV2Test: {
    // 确定链路走实验组样式开关，部分逻辑可利用ab 直接判断
    ab: false,
    defaultData: {
      lineStyle: 3,
      defaultCoverUrl: '',
      defaultTitle: '',
      guideTitle: ''
    },
    autoPush: true,
    // 当走实验组时，如果没有配置活动ID(true) 则走领课链路新样式全量（保留1.0逻辑交互）
    // 当走实验组时，如果配置了活动ID(false) 则走活动ID对应链路新样式
    // true 表示全量实验组
    // false 表示部分活动实验组
    noData: true,
    // 标签文案，和当前实验没关系
    labels: null
  },
  // 多科目联报测试
  multipleSubjectConfig: {
    activityIds: [],
    gradeConfig: null,
    guideConfig: null,
    skuConfig: null
  },
  // 定制活动配置（加老师解锁领课）
  customActivity: {
    isCustomActivity: false,
    threshold: 3,
    sourceType: '',
    freeBtnText: '',
    pageMapping: null
  },
  // 选课体验优化配置
  linkExperienceOptimizationConfig: null,
  getCustomActivityConfig: function getCustomActivityConfig(campaignId) {
    var _a;

    return __awaiter(this, void 0, void 0, function () {
      var resp, config, error_2;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _b.trys.push([0, 2,, 3]);

            return [4
            /*yield*/
            , getApolloKey('appAddTeacherPlaceOrderAbConfig')];

          case 1:
            resp = _b.sent();

            if ((resp === null || resp === void 0 ? void 0 : resp.resultCode) === 200 && resp.data) {
              config = canJsonParse(resp.data);

              if ((config === null || config === void 0 ? void 0 : config.campaignMapping) && config.campaignMapping[campaignId]) {
                this.customActivity = {
                  isCustomActivity: true,
                  threshold: config.threshold || 3,
                  sourceType: config.sourceType || '',
                  freeBtnText: config.freeBtnText || '',
                  pageMapping: ((_a = config.pageMapping) === null || _a === void 0 ? void 0 : _a[campaignId]) || null
                };
              }
            }

            return [3
            /*break*/
            , 3];

          case 2:
            error_2 = _b.sent();
            console.log('getCustomActivityConfig error:', error_2);
            return [3
            /*break*/
            , 3];

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  },
  // landingCampaignIds = [] 表示全量放开
  getLinkExperienceOptimizationConfig: function getLinkExperienceOptimizationConfig() {
    return __awaiter(this, void 0, void 0, function () {
      var resp, config, error_3;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            return [4
            /*yield*/
            , getApolloKey('linkExperienceOptimizationConfig')];

          case 1:
            resp = _a.sent();

            if ((resp === null || resp === void 0 ? void 0 : resp.resultCode) === 200 && resp.data) {
              config = canJsonParse(resp.data);

              if (config === null || config === void 0 ? void 0 : config.landingCampaignIds) {
                this.linkExperienceOptimizationConfig = {
                  landingCampaignIds: config.landingCampaignIds
                };
              }
            }

            return [3
            /*break*/
            , 3];

          case 2:
            error_3 = _a.sent();
            console.log('getLinkExperienceOptimizationConfig error:', error_3);
            return [3
            /*break*/
            , 3];

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  },
  getLinkV2Test: function getLinkV2Test(landingData) {
    return __awaiter(this, void 0, void 0, function () {
      var resp, res, campIdList, canAb, error_4;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            return [4
            /*yield*/
            , getApolloKey('marketing.link.test.v2')];

          case 1:
            resp = _a.sent();

            if (resp === null || resp === void 0 ? void 0 : resp.data) {
              res = canJsonParse(resp.data);
              campIdList = (res === null || res === void 0 ? void 0 : res.campainIdList) || [];
              canAb = false; // 配置种存在活动IDLIST 且当前活动ID存在于活动LIST 中 则走实验组
              // 配置种不存在活动IDLIST 则走全量实验组

              if (campIdList.length === 0 || campIdList.length > 0 && campIdList.indexOf(landingData.campaignId) > -1) {
                canAb = true;
              } // res.ab 控制是否走实验组


              this.linkV2Test = {
                ab: res.ab && canAb,
                defaultData: {},
                noData: true,
                autoPush: true,
                labels: (res === null || res === void 0 ? void 0 : res.labels) || null
              };
            }

            return [3
            /*break*/
            , 3];

          case 2:
            error_4 = _a.sent();
            console.log(error_4);
            return [3
            /*break*/
            , 3];

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  },
  initPageData: function initPageData(jumpAuth) {
    return __awaiter(this, void 0, void 0, function () {
      var channel, channelNo, linkId, callBackParam, href, sourceLink, params;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            channel = query.channel || '';
            channelNo = query.channelNo || '';
            linkId = query.linkId || '';
            callBackParam = query.callBackParam || '';
            href = window.location.href;
            sourceLink = href.replace(/#$/, '');
            params = {
              linkId: linkId,
              channel: channel,
              channelNo: channelNo,
              callBackParam: callBackParam,
              // sp91 增加当前完整链接透传 支持后端获取小度token
              sourceLink: sourceLink
            };
            return [4
            /*yield*/
            , Promise.all([getCampaignShow(params, jumpAuth), this.getDefaultAreaCode()])];

          case 1:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  },
  init: function init() {
    return __awaiter(this, void 0, void 0, function () {
      var isRedirect, isDiversion, appUrlKey, redirectAppUrl_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , handleAuth(true)];

          case 1:
            isRedirect = _a.sent();

            if (isRedirect) {
              return [2
              /*return*/
              ];
            }

            setSubDomainCookies('packageName', PACKAGE_NAME);
            return [4
            /*yield*/
            , this.diversion()];

          case 2:
            isDiversion = _a.sent();

            if (!isDiversion) {
              setTimeout(function () {
                var $root = document.getElementsByClassName('root-loading')[0];

                if ($root) {
                  $root.style.visibility = 'visible';
                }
              }, 500);
              this.render();
              this.tiktok();
            }

            appUrlKey = query.appUrlKey; // SP120 拦截叫叫阅读APP定级评估返回操作，并跳转指定 appUrlKey
            //! 注意 安卓APP 不能使用 tinman-router 协议在链接上，所以在跳转时需要拼接。外部方对接时 需要提醒外部

            if (appUrlKey) {
              redirectAppUrl_1 = APP_ROUTE_INDEX_MAP[appUrlKey] || APP_ROUTE_INDEX_MAP[2];
              interceptReadAppEvaluationBack({
                /**
                 * 当用户在APP中点击左上角关闭按钮时触发的回调函数
                 * 该函数会将当前页面替换为URL查询参数中的 appUrlKey 所指向的页面
                 */
                onClose: function onClose() {
                  // 将当前页面替换为 appUrlKey 指定的页面
                  jumpAppRoute(redirectAppUrl_1);
                },

                /**
                 * 当用户在APP中点击返回按钮时触发的回调函数
                 * 该函数会将当前页面替换为URL查询参数中的 appUrlKey 所指向的页面
                 */
                onBack: function onBack() {
                  // 将当前页面替换为 appUrlKey 指定的页面
                  jumpAppRoute(redirectAppUrl_1);
                }
              });
            }

            document.addEventListener('visibilitychange', function () {
              if (!document.hidden && isWeChat) {
                lazySizes.init();
              }
            });
            return [2
            /*return*/
            ];
        }
      });
    });
  },
  // 分流方法
  diversion: function diversion() {
    return __awaiter(this, void 0, void 0, function () {
      var linkId, _a, href, search, replaceUrl, res, diversionMap, data, countWeight_1, pre_1, maxArr_1, random, channel, memoSearch, idx, rUrl, e_1;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _b.trys.push([0, 3,, 4]);

            linkId = query.linkId;
            _a = window.location, href = _a.href, search = _a.search;
            replaceUrl = '';
            if (!(['71597457'].includes(linkId) || href.indexOf('shunt=1') > 0)) return [3
            /*break*/
            , 2];
            return [4
            /*yield*/
            , getApolloKey('FE_SHARE_REDIRECT_DIVERSION')];

          case 1:
            res = _b.sent();

            if (!res.data) {
              return [2
              /*return*/
              , false];
            }

            diversionMap = JSON.parse(res.data);
            data = diversionMap[linkId];

            if (!data) {
              return [2
              /*return*/
              , false];
            }

            countWeight_1 = 0; // 获取全部数量

            data.forEach(function (_a) {
              var proportion = _a.proportion;
              countWeight_1 += proportion;
            });
            pre_1 = 0;
            maxArr_1 = [];
            data.forEach(function (_a) {
              var proportion = _a.proportion;
              var w = Math.round(proportion / countWeight_1 * 100);
              pre_1 += w;
              maxArr_1.push(pre_1 > 97 ? 100 : pre_1);
            });
            random = Math.round(Math.random() * 100);
            channel = query.channel || '';
            memoSearch = "".concat(search.replace(/(\?|&)linkId=\d+|(\?|&)channel=(\w|-)+/gim, '')); // console.log(search, memoSearch);

            for (idx = 0; idx < maxArr_1.length; idx += 1) {
              if (random <= maxArr_1[idx]) {
                rUrl = data[idx].url;

                if (rUrl.includes('channel') || !channel) {
                  replaceUrl = rUrl + memoSearch;
                } else {
                  replaceUrl = "".concat(rUrl + (rUrl.includes('?') ? '&' : '?'), "channel=").concat(channel).concat(memoSearch);
                }

                break;
              }
            }

            if (!replaceUrl) {
              return [2
              /*return*/
              , false];
            }

            if (replaceUrl.includes("linkId=".concat(linkId))) {
              return [2
              /*return*/
              , false];
            } else {
              // console.log(data, replaceUrl);
              window.location.replace(replaceUrl);
              return [2
              /*return*/
              , true];
            }

            _b.label = 2;

          case 2:
            return [2
            /*return*/
            , false];

          case 3:
            e_1 = _b.sent();
            reportError(e_1);
            return [3
            /*break*/
            , 4];

          case 4:
            return [2
            /*return*/
            , false];
        }
      });
    });
  },
  getMultipleSubjectConfig: function getMultipleSubjectConfig(data) {
    return __awaiter(this, void 0, void 0, function () {
      var selectSkuContent, content;

      var _a;

      return __generator(this, function (_b) {
        try {
          selectSkuContent = data === null || data === void 0 ? void 0 : data.selectSkuContent;

          if ((data === null || data === void 0 ? void 0 : data.selectSkuStyle) === 'GRADE_CONTENT' && (selectSkuContent === null || selectSkuContent === void 0 ? void 0 : selectSkuContent.length)) {
            content = canJsonParse(selectSkuContent);
            this.multipleSubjectConfig = __assign(__assign({
              activityIds: [data.campaignId]
            }, content), {
              guideConfig: (_a = {}, _a[data.campaignId] = content.guideConfig, _a)
            });
          }
        } catch (error) {
          console.log(error);
        }

        return [2
        /*return*/
        ];
      });
    });
  },
  showPopupCondition: {
    data: {},
    hasTab: false
  },
  // 开始渲染页面模块
  render: function render() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;

    return __awaiter(this, void 0, void 0, function () {
      var href, platform, channel_1, channelNo, topic_name, linkId_1, callBackParam, $content, resp, defaultAreaCode, userAuth, status_1, needAuth, _m, resultCode, errorMsg, data_2, errMsg, errData, errHtml, sellRegionType, isForeign, _currency_1, apolloTasks, error_5, mdr, frontCampaignSkuResps, campaignId, campaignPageId, selectCourseTitle, answerAbTestType, campaignMode, interceptOrder, loadModules_1, loadModulesMap_1, loadModuleData_1, loadModulesIndex_1, moduleResps_1, existBottom, isNormalBottom, customerServiceModule, isCustomerServiceInline, showAnswrQuestion, answerConfData, existCourseSelection_1, isShowInPage, answerConf, sort, hasBottomButton, hasCourseSelection, hasLoginModule, modules, ab, sensData, abTestSensData, loadModulesLength, eleArr_1, tabModuleIndex, tabModule, tabExtra, tabButtons, hasTabHeadImg, bottomBtnModuleContent, customFreeBtnText, accountSwitcherModule, accountSwitcher, accountExtra, asHtml, asDom, _loop_1, this_1, index, children_1, btnGroupInstance, btnGroupData, $btnGroupDom, module_1, accountSwitcherInstance, $accountSwitcherDom, accountSwitcherData, hasTabOrderBtn, tabModules, needRenderCourseSelection, courseSelection, module_2, skuSelection, skuSelectionModule, notShowShare, popConfigPromise, e_2;

      var _o, _p;

      var _this = this;

      return __generator(this, function (_q) {
        switch (_q.label) {
          case 0:
            _q.trys.push([0, 25, 26, 27]);

            if ((query === null || query === void 0 ? void 0 : query.aliToken) && !isWXBrowser()) {
              aliPreparePay({
                token: query === null || query === void 0 ? void 0 : query.aliToken
              });
              return [2
              /*return*/
              ];
            }

            href = window.location.href;

            if (!href.includes('vPhone=') && window.localStorage) {
              storage.set(INDEX_URL, href.replace(/#$/, ''));
            }

            return [4
            /*yield*/
            , getCurrPlatform()];

          case 1:
            platform = _q.sent();
            channel_1 = query.channel || '';
            channelNo = query.channelNo || '';
            topic_name = query.sceneLabel || '';
            linkId_1 = query.linkId || '';
            callBackParam = query.callBackParam || '';
            $content = document.createDocumentFragment();
            resp = {};
            defaultAreaCode = '';
            userAuth = void 0;
            if (!(isWeChat || isJoJoApp)) return [3
            /*break*/
            , 6];
            return [4
            /*yield*/
            , this.initPageData(false)];

          case 2:
            // 微信登陆后置，先看是否需要登陆
            // resp = await getCampaignShow<ShowResType>(params, false);
            _o = _q.sent(), resp = _o[0], defaultAreaCode = _o[1];
            status_1 = (resp || {}).status;
            needAuth = [1001, 1005].includes(status_1);
            if (!needAuth) return [3
            /*break*/
            , 4];
            return [4
            /*yield*/
            , getCampaignShow({
              channel: channel_1,
              channelNo: channelNo,
              linkId: linkId_1,
              callBackParam: callBackParam
            })];

          case 3:
            // 走不鉴权的接口
            resp = _q.sent();
            userAuth = false;
            return [3
            /*break*/
            , 5];

          case 4:
            if (uc_switch && isWXAppBrowser()) {
              // 该操作用于UC切换后，前置获取unionId，复用之前的登录后置，排除小程序
              userAuth = Boolean(Cookie.get('wxUnionId'));
            } else {
              userAuth = true;
            }

            _q.label = 5;

          case 5:
            return [3
            /*break*/
            , 8];

          case 6:
            return [4
            /*yield*/
            , this.initPageData(false)];

          case 7:
            _p = _q.sent(), resp = _p[0], defaultAreaCode = _p[1];
            _q.label = 8;

          case 8:
            _m = resp, resultCode = _m.resultCode, errorMsg = _m.errorMsg, data_2 = _m.data; // 站外或用户未登陆必须输入手机号

            if (data_2 && (platform === 3 || !uid)) {
              data_2.useMobile = 1;
            }

            if (resultCode !== 200) {
              sensAutoTrack({
                channel: channel_1,
                channelNo: channelNo,
                topic_name: topic_name,
                url_id: linkId_1,
                activity_label: '投放',
                $title: '投放活动落地页',
                $element_target_url: (query === null || query === void 0 ? void 0 : query.inviteCode) || ''
              });
              errMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.replace('连接', '链接')) !== null && _a !== void 0 ? _a : errorMsg;
              errData = {
                title: errMsg,
                desc: errMsg
              };

              if ([2001, 2002].includes(resultCode)) {
                errData.title = '活动已经结束啦';
                errData.desc = '下期活动 尽请期待';
              }

              document.title = errData.title || ''; // 没有错误信息

              if (!errData.title) {
                return [2
                /*return*/
                ];
              }

              errHtml = "\n      <div class=\"error-page\">\n        <div class=\"title\">\n          ".concat(errData.title, "\n        </div>\n        <div class=\"desc\">\n        ").concat(errData.desc, "\n        </div>\n      </div> \n      ");
              document.body.appendChild(stringToDom(errHtml));
              return [2
              /*return*/
              ];
            }

            this.showPopupCondition.data = data_2;
            sellRegionType = ((_c = (_b = data_2 === null || data_2 === void 0 ? void 0 : data_2.frontCampaignSkuResps) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.sellRegionType) || 'MAINLAND_CHINA';
            isForeign = sellRegionType === 'FOREIGN';
            _currency_1 = isForeign ? 'USD $' : '¥';

            if (window.__store) {
              window.__store.sellRegionType = sellRegionType;
              window.__store._currency = _currency_1;
            } else {
              window.__store = {
                sellRegionType: sellRegionType,
                _currency: _currency_1
              };
            }

            _q.label = 9;

          case 9:
            _q.trys.push([9, 11,, 12]);

            apolloTasks = [this.getLinkV2Test(data_2), this.getMultipleSubjectConfig(data_2), // 获取选课体验优化配置
            this.getLinkExperienceOptimizationConfig()]; // 获取定制活动配置（加老师解锁领课），仅在 JOJO Read APP 内生效

            if (isJoJoReadApp) {
              apolloTasks.push(this.getCustomActivityConfig(data_2.campaignId));
            }

            return [4
            /*yield*/
            , Promise.all(apolloTasks)];

          case 10:
            _q.sent();

            return [3
            /*break*/
            , 12];

          case 11:
            error_5 = _q.sent();
            console.log(error_5);
            return [3
            /*break*/
            , 12];

          case 12:
            if (/[0-4]/g.test("".concat(data_2 === null || data_2 === void 0 ? void 0 : data_2.answerAbTestType))) {
              data_2.answerAbTestType = Number(data_2.answerAbTestType);
            }

            mdr = data_2.moduleResps, frontCampaignSkuResps = data_2.frontCampaignSkuResps, campaignId = data_2.campaignId, campaignPageId = data_2.campaignPageId, selectCourseTitle = data_2.selectCourseTitle, answerAbTestType = data_2.answerAbTestType, campaignMode = data_2.campaignMode; // 头图 preload —— 与后续模块渲染并行下载，加速 LCP

            preloadHeroImage(mdr);

            try {
              if (campaignId) {
                sensors.use(Pageleave, {
                  custom_props: {
                    activity_id: campaignId,
                    channel: channel_1,
                    channel_no: channelNo,
                    url_id: linkId_1,
                    activity_label: '投放',
                    material_ids: ["".concat(campaignPageId)]
                  },
                  heartbeat_interval_time: 5,
                  max_duration: 5 * 24 * 60 * 60
                });
              }
            } catch (error) {
              console.log(error);
            } // 行为埋点


            if (!(query.fr === 'bg')) {
              userActionRecord({
                sceneType: 'MARKETING',
                userType: 'INITIATIVE',
                actionType: '浏览',
                actionContent: '领课落地页浏览',
                data: {
                  activityId: campaignId,
                  activityPageId: campaignPageId,
                  clickId: query.clickid || query.qz_gdt || query.gdt_vid || '',
                  creativityId: query.creativeid || query.ad_id || '',
                  linkId: linkId_1,
                  channel: channel_1,
                  channelNo: channelNo
                }
              });
            }

            interceptOrder = Array.isArray(frontCampaignSkuResps) && frontCampaignSkuResps.every(function (_a) {
              var channelSegmentLimitFlag = _a.channelSegmentLimitFlag;
              return channelSegmentLimitFlag;
            }) && mdr.findIndex(function (_a) {
              var moduleType = _a.moduleType;
              return [3, 5].includes(moduleType);
            }) >= 0;
            data_2.userAuth = userAuth;
            data_2.defaultAreaCode = defaultAreaCode; // 未配置选课标题的，使用默认标题

            if (!selectCourseTitle) {
              data_2.selectCourseTitle = '请根据孩子9月升学的年级选择';
            }

            loadModules_1 = [];
            loadModulesMap_1 = {};
            loadModuleData_1 = [];
            loadModulesIndex_1 = 0;
            moduleResps_1 = interceptOrder ? mdr.filter(function (_a) {
              var moduleType = _a.moduleType;
              return ![3, 4, 5, 7].includes(moduleType);
            }) : mdr;
            existBottom = moduleResps_1.find(function (i) {
              return (i === null || i === void 0 ? void 0 : i.moduleType) === 5;
            });
            isNormalBottom = existBottom && [1, 2].includes(existBottom === null || existBottom === void 0 ? void 0 : existBottom.moduleSubType);
            customerServiceModule = moduleResps_1.find(function (i) {
              return (i === null || i === void 0 ? void 0 : i.moduleType) === 16;
            });
            isCustomerServiceInline = customerServiceModule && existBottom && [1, 2].includes(existBottom === null || existBottom === void 0 ? void 0 : existBottom.moduleSubType);
            showAnswrQuestion = answerAbTestType && (isNormalBottom || !existBottom);
            answerConfData = null;
            if (!showAnswrQuestion) return [3
            /*break*/
            , 15];
            existCourseSelection_1 = false;
            moduleResps_1 = moduleResps_1.filter(function (_a) {
              var moduleType = _a.moduleType;

              if (moduleType === 3) {
                existCourseSelection_1 = true;
              }

              return moduleType !== 3;
            });
            isShowInPage = answerAbTestType > 1;
            if (!isShowInPage) return [3
            /*break*/
            , 14];
            return [4
            /*yield*/
            , getQuestionConfig({
              campaignId: campaignId
            })];

          case 13:
            answerConf = _q.sent().data;
            answerConfData = answerConf;
            _q.label = 14;

          case 14:
            sort = 1; // 如果第一位是按钮，因为按钮会浮动，所以将答题模块插入第3位

            if (isNormalBottom && (moduleResps_1 === null || moduleResps_1 === void 0 ? void 0 : moduleResps_1[0].moduleType) === 5) {
              sort = 2;
            }

            moduleResps_1.splice(sort, 0, {
              bizId: 0,
              bizType: 0,
              moduleType: 999,
              moduleSubType: 1,
              moduleContent: '',
              moduleLink: '',
              moduleExtra: '{}',
              moduleId: ''
            }); // 挂载答题组件方法
            // const answerQuestion = await import('@/modules/landing/CourseSelection');
            // const answerQuestionModule = answerQuestion.default;
            // console.log('answerQuestion=', answerQuestionModule);
            // module.render({ data });
            // module.mount();
            // 对于有选课组件无按钮，要渲染默认按钮

            if (!existBottom && existCourseSelection_1) {
              moduleResps_1.push({
                bizId: 0,
                bizType: 0,
                moduleType: 5,
                moduleSubType: 1,
                moduleContent: '',
                moduleLink: '',
                moduleExtra: '{}',
                moduleId: ''
              });
            }

            _q.label = 15;

          case 15:
            moduleResps_1.forEach(function (_a, index) {
              var moduleType = _a.moduleType;
              var moduleName = modulesMap[moduleType];

              if (moduleName) {
                loadModulesMap_1[index] = loadModulesIndex_1;
                loadModulesIndex_1 += 1;
                loadModuleData_1.push(moduleResps_1[index]);
                loadModules_1.push(import("@/modules/landing/".concat(moduleName)));
              }
            });
            hasBottomButton = false;
            hasCourseSelection = false;
            hasLoginModule = false;
            return [4
            /*yield*/
            , Promise.all(loadModules_1.filter(function (r) {
              return r;
            }))];

          case 16:
            modules = _q.sent(); // needlessChooseCourse = 1 答题模式需要隐藏选课组件。= 0 时是选课组件不隐藏

            if (data_2.needlessChooseCourse === 0) {
              // 选课模式时当sku数量 > 1 不隐藏选课组件。 = 1 隐藏选课组件
              data_2.needlessChooseCourse = data_2.frontCampaignSkuResps.length > 1 || ((_d = data_2 === null || data_2 === void 0 ? void 0 : data_2.otherSkuResps) === null || _d === void 0 ? void 0 : _d.length) ? 0 : 1;
            }

            ab = data_2 === null || data_2 === void 0 ? void 0 : data_2.answerAbTestType;

            try {
              sensData = {
                sku_id: frontCampaignSkuResps.map(function (_a) {
                  var skuId = _a.skuId;
                  return skuId;
                }).join(','),
                course_key: frontCampaignSkuResps.map(function (_a) {
                  var courseKey = _a.courseKey;
                  return courseKey;
                }).join(','),
                channel: channel_1,
                channel_no: channelNo,
                activity_id: campaignId,
                url_id: linkId_1,
                activity_label: '投放',
                $title: '投放活动落地页',
                $element_target_url: (query === null || query === void 0 ? void 0 : query.inviteCode) || '',
                material_ids: [campaignPageId].map(function (item) {
                  return item.toString();
                }),
                ab: ab,
                ua: window.navigator.userAgent || ''
              };
              abTestSensData = {
                ab: ab,
                ua: window.navigator.userAgent || ''
              };
              saveAbTestSensData(abTestSensData);
              saveSensData(sensData);
              sensAutoTrack(__assign(__assign({}, sensData), {
                material_type: (query === null || query === void 0 ? void 0 : query.boomId) || '',
                custom_state: query.boomPoster || '',
                topic_name: topic_name
              }));
            } catch (error) {
              console.log(error);
            }

            loadModulesLength = moduleResps_1.length;
            eleArr_1 = [];
            tabModuleIndex = moduleResps_1 === null || moduleResps_1 === void 0 ? void 0 : moduleResps_1.findIndex(function (el) {
              return (el === null || el === void 0 ? void 0 : el.moduleType) === 8;
            });
            this.showPopupCondition.hasTab = tabModuleIndex > -1;
            tabModule = moduleResps_1 === null || moduleResps_1 === void 0 ? void 0 : moduleResps_1[tabModuleIndex];
            tabExtra = JSON.parse((tabModule === null || tabModule === void 0 ? void 0 : tabModule.moduleExtra) || '{}');
            tabButtons = (tabExtra || {}).tabButtons;
            hasTabHeadImg = tabButtons === null || tabButtons === void 0 ? void 0 : tabButtons.find(function (el) {
              return el.headImg;
            });
            bottomBtnModuleContent = ((_e = moduleResps_1.find(function (el) {
              return (el === null || el === void 0 ? void 0 : el.moduleType) === 5;
            })) === null || _e === void 0 ? void 0 : _e.moduleContent) || '';
            customFreeBtnText = ((_f = this.customActivity.pageMapping) === null || _f === void 0 ? void 0 : _f.freeBtnText) || this.customActivity.freeBtnText || '添加学习顾问免费解锁';
            accountSwitcherModule = moduleResps_1.find(function (el) {
              return (el === null || el === void 0 ? void 0 : el.moduleType) === 18;
            });
            if (!accountSwitcherModule) return [3
            /*break*/
            , 18];
            return [4
            /*yield*/
            , import('@/modules/landing/AccountSwitcher')];

          case 17:
            accountSwitcher = _q.sent();
            accountExtra = canJsonParse(accountSwitcherModule.moduleExtra) || {};
            asHtml = accountSwitcher.default.render(accountExtra);
            asDom = stringToDom(asHtml);
            $content.appendChild(asDom); // 保存引用用于 mount 阶段

            this._accountSwitcherInstance = accountSwitcher.default;
            this._accountSwitcherData = accountSwitcherModule;
            _q.label = 18;

          case 18:
            _loop_1 = function _loop_1(index) {
              var _r = moduleResps_1[index],
                  moduleType = _r.moduleType,
                  moduleLink = _r.moduleLink,
                  moduleContent = _r.moduleContent,
                  moduleSubType = _r.moduleSubType,
                  moduleExtra = _r.moduleExtra,
                  moduleId = _r.moduleId;
              var modIndex = loadModulesMap_1[index];

              if (typeof modIndex === 'number') {
                var module_3 = modules[modIndex];
                var de = module_3.default;
                var dom = null;
                var str = '';

                if (typeof de.render === 'function') {
                  str = de.render(__assign(__assign({}, data_2), {
                    // SP110 渲染2.0选课组件样式
                    linkV2Test: this_1.linkV2Test,
                    // SP112 多科目联报测试样式
                    multipleSubjectConfig: this_1.multipleSubjectConfig,
                    // 定制活动配置（加老师解锁领课）
                    isCustomActivity: this_1.customActivity.isCustomActivity,
                    customActivityConfig: {
                      threshold: this_1.customActivity.threshold,
                      sourceType: this_1.customActivity.sourceType,
                      pageMapping: this_1.customActivity.pageMapping,
                      freeBtnText: customFreeBtnText
                    },
                    // 底部按钮文案（页面模块数据，供弹窗使用）
                    payBtnText: bottomBtnModuleContent,
                    // 选课体验优化配置
                    linkExperienceOptimizationConfig: this_1.linkExperienceOptimizationConfig,
                    moduleSubType: moduleSubType,
                    render: true,
                    linkId: query.linkId || '',
                    channel: query.channel || '',
                    channelNo: query.channelNo || '',
                    moduleContent: moduleContent,
                    moduleExtra: moduleExtra,
                    moduleId: moduleId,
                    answerConfData: answerConfData
                  }));
                  dom = stringToDom(str);
                }

                if (dom && str) {
                  $content.appendChild(dom);

                  if (tabModuleIndex > -1) {
                    // 有TAB组件，再判断hasFisrtLinkImg 是否为true
                    // hasFisrtLinkImg === undefined 落地页没有添加图片组件
                    // hasFisrtLinkImg === false 说明tab组件索引前没有设置图片组件
                    // hasFirstLinkImg === true tab组件索引前有图片组件
                    eleArr_1.push(data_2.hasFisrtLinkImg === true || !hasTabHeadImg ? $content.childElementCount - 1 : $content.childElementCount);
                  } else {
                    eleArr_1.push($content.childElementCount - 1);
                  }
                } // 判断是否渲染后课程选择组件


                if (moduleType === 3) {
                  hasCourseSelection = true;
                } // 判断是否有登录下单组件


                if (moduleType === 15) {
                  hasLoginModule = true;
                }
              } else {
                switch (moduleType) {
                  case 1:
                    {
                      // SP96 落地页头图切换改造
                      var moduleExtraData = canJsonParse(moduleExtra); // materialScene 跳转场景value对应链接上的跳转参数名称，materialId 素材id，materialName 素材名称

                      var materialId_1 = moduleExtraData.materialId,
                          materialName_1 = moduleExtraData.materialName,
                          materialScene = moduleExtraData.materialScene;
                      var jumpLink = (query === null || query === void 0 ? void 0 : query[materialScene]) || moduleLink || '';
                      var link = jumpLink ? document.createElement('a') : document.createElement('div');

                      if (!isJoJoReadApp && /^tinman-router:\/\//i.test(jumpLink)) {
                        link = document.createElement('div');
                      }

                      var firstRenderImg = moduleContent;
                      var clsStr = 'container link-img';
                      var firstImgIndex = moduleResps_1 === null || moduleResps_1 === void 0 ? void 0 : moduleResps_1.findIndex(function (el) {
                        return (el === null || el === void 0 ? void 0 : el.moduleType) === 1;
                      }); // 判断tab组件在图片组件之后且tab组件里面配置了头图切换的素材，才可替换头图

                      if (tabModuleIndex > firstImgIndex && firstImgIndex === index && hasTabHeadImg) {
                        link = document.createElement('div');
                        data_2.hasFisrtLinkImg = true;
                        data_2.defaultFirstImgObj = {
                          moduleContent: moduleContent,
                          moduleLink: moduleLink
                        };
                        clsStr = 'container link-img first-link-img';
                      }

                      addClass(link, clsStr);
                      var img_1 = new Image();
                      img_1.alt = '图片';

                      if (link.tagName === 'A') {
                        link.href = jumpLink;
                      }

                      try {
                        var onClick = function onClick() {
                          sensClickInitiative({
                            $element_name: '投放落地页_组件点击',
                            $element_id: moduleId,
                            material_id: materialId_1,
                            material_name: materialName_1
                          });
                        };

                        link.addEventListener('click', onClick);
                        Exposure(img_1, {
                          material_id: materialId_1,
                          material_name: materialName_1,
                          material_type: moduleId,
                          c_element_name: '投放落地页_素材浏览'
                        });
                      } catch (error) {
                        console.log(error);
                      }

                      if (tabModule && (tabModule === null || tabModule === void 0 ? void 0 : tabModule.moduleExtra) && tabModuleIndex > firstImgIndex && firstImgIndex === index) {
                        var defaultTab = (tabButtons === null || tabButtons === void 0 ? void 0 : tabButtons.find(function (el) {
                          return el.tabDefaultHidden && el.headImg;
                        })) || (tabButtons === null || tabButtons === void 0 ? void 0 : tabButtons.find(function (el) {
                          return el.headImg;
                        })) || (tabButtons === null || tabButtons === void 0 ? void 0 : tabButtons[0]);

                        if (defaultTab && (defaultTab === null || defaultTab === void 0 ? void 0 : defaultTab.headImg)) {
                          firstRenderImg = defaultTab === null || defaultTab === void 0 ? void 0 : defaultTab.headImg;
                        }
                      }

                      var imgSrc = connectLink(firstRenderImg);

                      if (index > 1) {
                        img_1.src = PLACEHOLDER_MAP;
                        addClass(img_1, 'lazyload');
                        img_1.setAttribute('data-src', imgSrc);
                      } else {
                        // 仅 GIF 应用大图优化，缩小影响范围
                        var isGif = /\.gif(\?|#|$)/i.test(imgSrc);

                        if (isGif) {
                          // 异步解码，避免 10MB GIF 解码阻塞主线程
                          img_1.decoding = 'async';
                          img_1.addEventListener('error', function () {
                            if (img_1.src !== PLACEHOLDER_MAP) {
                              img_1.src = PLACEHOLDER_MAP;
                            }
                          });
                          img_1.setAttribute('fetchpriority', 'high');
                        }

                        img_1.src = imgSrc;
                      }

                      link.appendChild(img_1);
                      $content.appendChild(link);
                      exposureModule(link, {
                        module: {
                          moduleId: moduleId
                        }
                      });
                      break;
                    }

                  case 5:
                    {
                      // 渲染页面底部的按钮
                      hasBottomButton = true;

                      if (this_1.customActivity.isCustomActivity) {
                        // 命中定制活动，渲染底部双按钮组合组件
                        var payBtnText = moduleContent || '';
                        var btnGroupInstance = new BottomButtonGroup();
                        var btnGroupTpl = btnGroupInstance.render({
                          payBtnText: payBtnText,
                          freeBtnText: customFreeBtnText,
                          isSingleSku: frontCampaignSkuResps.length === 1,
                          campaignId: campaignId,
                          campaignPageId: campaignPageId
                        });
                        $content.appendChild(stringToDom(btnGroupTpl)); // 保存实例用于后续 mount

                        this_1._bottomButtonGroupInstance = btnGroupInstance;
                        this_1._bottomButtonGroupData = {
                          payBtnText: payBtnText,
                          freeBtnText: customFreeBtnText,
                          isSingleSku: frontCampaignSkuResps.length === 1,
                          campaignId: campaignId,
                          campaignPageId: campaignPageId
                        };
                      } else {
                        var btnTpl = bottomButton.render(data_2, moduleResps_1[index], {
                          isWithCustomerService: !!isCustomerServiceInline
                        }); // X-P0 客服入口组件 inline 模式：与下单按钮并排展示

                        if (isCustomerServiceInline && customerServiceModule) {
                          var customerServiceHtml = customerServiceButton.render({
                            mode: 'inline',
                            moduleResp: customerServiceModule
                          });
                          btnTpl = btnTpl.replace('<div class="btn">', "<div class=\"btn\">".concat(customerServiceHtml));
                        }

                        $content.appendChild(stringToDom(btnTpl));
                      }

                      break;
                    }

                  case 16:
                    {
                      // X-P0 客服入口组件 standalone 模式：独立吸底展示
                      if (customerServiceModule && !isCustomerServiceInline) {
                        var customerServiceTpl = customerServiceButton.render({
                          mode: 'standalone',
                          moduleResp: customerServiceModule
                        });
                        $content.appendChild(stringToDom(customerServiceTpl));
                      }

                      break;
                    }

                  default:
                    {
                      break;
                    }
                }
              }
            };

            this_1 = this; // 判断tab组件是否设置切换的头图

            for (index = 0; index < loadModulesLength; index++) {
              _loop_1(index);
            }

            this.ele.$root.removeAttribute('class'); // SP111 实验样式

            if (this.linkV2Test.ab) {
              addClass(this.ele.$root, 'root-white');
            }

            this.ele.$root.appendChild($content); // tdid 延迟至主内容渲染完成后加载，移出关键渲染路径

            sdkLoader.loadTdid();
            children_1 = this.ele.$root.children; // 调用mount模块方法

            modules.forEach(function (module, index) {
              var de = module.default;

              if (typeof de.mount === 'function') {
                var dom = children_1[eleArr_1[index]];
                var moduleType = (loadModuleData_1[index] || {}).moduleType;

                if (moduleType !== 9) {
                  // 用户评价组件在初始加载时是空div，所以用户评价在组件内绑定曝光
                  exposureModule(dom, {
                    module: loadModuleData_1[index]
                  });
                }

                de.mount(dom, _this.ele.$root, {
                  show: data_2,
                  module: loadModuleData_1[index],
                  index: index
                });
              }
            }); // 底部有按钮挂载方法

            if (hasBottomButton) {
              if (this.customActivity.isCustomActivity) {
                btnGroupInstance = this._bottomButtonGroupInstance;
                btnGroupData = this._bottomButtonGroupData;
                $btnGroupDom = this.ele.$root.querySelector('.bottom-button-group');

                if (btnGroupInstance && $btnGroupDom) {
                  btnGroupInstance.mount($btnGroupDom, btnGroupData);
                }

                if (this.ele.$root) {
                  addClass(this.ele.$root, 'pdbm136');
                  addClass(this.ele.$root, 'root-blank');
                }
              } else {
                module_1 = moduleResps_1.find(function (i) {
                  return i.moduleType === 5;
                });
                bottomButton.mount(this.ele.$root, {
                  module: module_1
                }); // X-P0 客服入口组件 inline 模式挂载

                if (isCustomerServiceInline && customerServiceModule) {
                  customerServiceButton.mount(this.ele.$root, {
                    module: customerServiceModule
                  });
                }
              }
            } // X-P0 客服入口组件 standalone 模式挂载


            if (customerServiceModule && !isCustomerServiceInline) {
              customerServiceButton.mount(this.ele.$root, {
                module: customerServiceModule
              });

              if (this.ele.$root) {
                addClass(this.ele.$root, 'pdbm136');
                addClass(this.ele.$root, 'root-blank');
              }
            }

            accountSwitcherInstance = this._accountSwitcherInstance;

            if (accountSwitcherInstance) {
              $accountSwitcherDom = this.ele.$root.querySelector('.account-switcher');
              accountSwitcherData = this._accountSwitcherData;

              if ($accountSwitcherDom) {
                accountSwitcherInstance.mount($accountSwitcherDom, this.ele.$root, {
                  module: accountSwitcherData,
                  campaignId: campaignId
                });
              }
            }

            hasTabOrderBtn = false; // tab下是否有下单按钮

            if (!hasBottomButton && !hasCourseSelection) {
              tabModules = loadModuleData_1 === null || loadModuleData_1 === void 0 ? void 0 : loadModuleData_1.filter(function (module) {
                return (module === null || module === void 0 ? void 0 : module.moduleType) === 8;
              });
              hasTabOrderBtn = tabModules === null || tabModules === void 0 ? void 0 : tabModules.some(function (tab) {
                try {
                  var tabData = tab.moduleExtra.indexOf('tabButtons') >= 0 ? JSON.parse(tab.moduleExtra) : {};

                  if (tabData.tabButtons) {
                    return tabData.tabButtons.some(function (i) {
                      var tabContents = i.tabContents;
                      return tabContents.some(function (e) {
                        return e.type === 'BUTTON' && e.buttonType === 'ORDER';
                      });
                    });
                  }

                  return false;
                } catch (_a) {
                  return false;
                }
              });
            }

            needRenderCourseSelection = hasBottomButton || hasLoginModule || hasTabOrderBtn && campaignMode === 'CLASSIC_MODE';
            if (!(needRenderCourseSelection && !hasCourseSelection)) return [3
            /*break*/
            , 20];
            return [4
            /*yield*/
            , import('@/modules/landing/CourseSelection')];

          case 19:
            courseSelection = _q.sent();
            module_2 = courseSelection.default;
            module_2.render(__assign(__assign({}, data_2), {
              linkV2Test: this.linkV2Test,
              // 定制活动配置（加老师解锁领课）
              isCustomActivity: this.customActivity.isCustomActivity,
              customActivityConfig: {
                threshold: this.customActivity.threshold,
                pageMapping: this.customActivity.pageMapping
              },
              // 底部按钮文案（页面模块数据，供弹窗使用）
              payBtnText: bottomBtnModuleContent,
              // 选课体验优化配置
              linkExperienceOptimizationConfig: this.linkExperienceOptimizationConfig,
              moduleSubType: 3,
              render: false,
              linkId: query.linkId || '',
              channel: query.channel || '',
              channelNo: query.channelNo || ''
            }));
            module_2.mount();
            _q.label = 20;

          case 20:
            if (!(hasTabOrderBtn && campaignMode === 'NO_SKU')) return [3
            /*break*/
            , 22];
            return [4
            /*yield*/
            , import('@/modules/landing/SkuSelection')];

          case 21:
            skuSelection = _q.sent();
            skuSelectionModule = skuSelection.default;
            skuSelectionModule.render(__assign(__assign({}, data_2 || {}), {
              linkId: query.linkId || '',
              channel: query.channel || '',
              channelNo: query.channelNo || ''
            }));
            skuSelectionModule.mount();
            _q.label = 22;

          case 22:
            // 微信分享
            if (data_2.campaignShareResp) {
              this.weChatConf(data_2.campaignShareResp);
            } //


            replaceStateInMiniApp({
              shareUrl: window.location.href,
              shareImage: checkUrl((_g = data_2 === null || data_2 === void 0 ? void 0 : data_2.campaignShareResp) === null || _g === void 0 ? void 0 : _g.shareUrl) || '',
              shareTitle: ((_h = data_2 === null || data_2 === void 0 ? void 0 : data_2.campaignShareResp) === null || _h === void 0 ? void 0 : _h.shareName) || '和我一起加入叫叫大家庭吧'
            });
            notShowShare = sellRegionType === 'FOREIGN';
            appShareH5Config({
              data: {
                title: ((_j = data_2 === null || data_2 === void 0 ? void 0 : data_2.campaignShareResp) === null || _j === void 0 ? void 0 : _j.shareName) || '叫叫',
                desc: ((_k = data_2 === null || data_2 === void 0 ? void 0 : data_2.campaignShareResp) === null || _k === void 0 ? void 0 : _k.shareDesc) || '和我一起加入叫叫大家庭吧',
                imgUrl: checkUrl((_l = data_2 === null || data_2 === void 0 ? void 0 : data_2.campaignShareResp) === null || _l === void 0 ? void 0 : _l.shareUrl) || ''
              },
              notShowShare: notShowShare
            });
            popConfigPromise = listPopConfig({
              bizId: data_2.campaignPageId,
              bizType: 1,
              fillNull: 0
            }).then(function (_a) {
              var popCode = _a.resultCode,
                  popData = _a.data;
              if (popCode !== 200) return null;
              return popData;
            }).catch(function () {
              return null;
            });
            this.showPopup(data_2.campaignPageId, data_2 === null || data_2 === void 0 ? void 0 : data_2.campaignId, popConfigPromise);
            setTimeout(function () {
              _this.vivoReport();

              _this.setGlobalCookies(channel_1, linkId_1); // SP119 新增图灵盾初始化逻辑(延迟异步处理)


              initTsecTuring();
            }, 1000);
            if (!(query.fr !== 'bg')) return [3
            /*break*/
            , 24];
            return [4
            /*yield*/
            , pointReportMsg('PAGE_SHOW', {
              action: 'browse',
              channelid: query.channel
            })];

          case 23:
            _q.sent();

            _q.label = 24;

          case 24:
            if (interceptOrder) {
              // this.interceptPrompt();
              Toast.fail('抱歉，活动已结束!', 1000 * 1000);
            }

            return [3
            /*break*/
            , 27];

          case 25:
            e_2 = _q.sent();
            console.log(e_2);
            reportError(e_2);
            return [3
            /*break*/
            , 27];

          case 26:
            return [7
            /*endfinally*/
            ];

          case 27:
            return [2
            /*return*/
            ];
        }
      });
    });
  },

  /* interceptPrompt() {
    appendPrompt({
      content: `
      <div class="ui-prompt-selection">
        <h4 class="tit">提示</h4>
        <div class="desc">抱歉，活动已结束</div>
        <button class="btn">知道了</button>
      </div>
      `,
      onMount: (content) => {
        const $ct = content;
           $ct.onclick = (e) => {
          const ev = e || window.event;
          ev.stopPropagation();
          const target = (ev.target || ev.srcElement) as HTMLDivElement;
          // 立即报名
          if (target && hasClass(target, 'btn')) {
            $ct.onclick = null;
            document.body.removeChild($ct);
          }
        };
      }
    });
  }, */
  // 获取弹窗
  showPopup: function showPopup(bizId, campaignId, popConfigPromise) {
    var _a, _b, _c, _d, _e, _f, _g, _h;

    return __awaiter(this, void 0, void 0, function () {
      var sessionKey, hasShown, configs, _j, resultCode, data, retainItem_1, item_1, supportApp, currentItem_1, isClassicMode, noTab, $content_1, $btn, $img, $link, e_3;

      var _this = this;

      return __generator(this, function (_k) {
        switch (_k.label) {
          case 0:
            //! 大促特殊判断, 完后删除
            if (query.fr === 'bg') {
              return [2
              /*return*/
              ];
            }

            sessionKey = "popup_shown_".concat(bizId);
            hasShown = false;

            try {
              hasShown = !!sessionStorage.getItem(sessionKey);
            } catch (_l) {// sessionStorage 不可用（如 Safari 隐私模式），降级为不去重
            }

            if (hasShown) return [2
            /*return*/
            ];
            _k.label = 1;

          case 1:
            _k.trys.push([1, 6,, 7]);

            configs = null;
            if (!popConfigPromise) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , popConfigPromise];

          case 2:
            // 使用并发预取的弹窗配置（与页面渲染并行）
            configs = _k.sent();
            return [3
            /*break*/
            , 5];

          case 3:
            return [4
            /*yield*/
            , listPopConfig({
              bizId: bizId,
              bizType: 1,
              fillNull: 0
            })];

          case 4:
            _j = _k.sent(), resultCode = _j.resultCode, data = _j.data;

            if (resultCode !== 200) {
              return [2
              /*return*/
              ];
            }

            configs = data;
            _k.label = 5;

          case 5:
            retainItem_1 = null;
            item_1 = null; // SP101 存储前先清除storage

            storage.remove("config_pop_banner_".concat(bizId));
            configs === null || configs === void 0 ? void 0 : configs.forEach(function (el) {
              if ((el === null || el === void 0 ? void 0 : el.popTrigger) === 1) {
                item_1 = el;
              }

              if ((el === null || el === void 0 ? void 0 : el.popTrigger) === 2) {
                retainItem_1 = el;
              }

              if ((el === null || el === void 0 ? void 0 : el.popTrigger) === 4) {
                // SP101 存储banner数据
                storage.set("config_pop_banner_".concat(bizId), el);
              }
            });
            supportApp = isJoJoAllBrowser(); // 落地页挽留弹窗配置

            if (supportApp && retainItem_1 && !storage.get("landing_retain_".concat(bizId)) && canUseBridge) {
              try {
                doIntercept('true');
                window.addEventListener('beforeunload', function () {
                  doIntercept('false');
                  bridge.off('appCalljs_autoGoBackFn', function () {
                    return {
                      goBack: true
                    };
                  });
                });
                bridge.on('appCalljs_autoGoBackFn', function () {
                  AppCalljsGoBackFn(retainItem_1, {
                    bizId: bizId,
                    campaignId: campaignId
                  });
                  return {
                    goBack: false
                  };
                });
              } catch (e) {
                console.log(e);
              }
            } // 落地页进入弹窗配置


            if (!item_1) return [2
            /*return*/
            ]; // 标记已展示（去重），try-catch 包裹，写入失败不影响弹窗展示

            try {
              sessionStorage.setItem(sessionKey, '1');
            } catch (_m) {// sessionStorage 写入失败，静默处理
            }

            currentItem_1 = item_1;

            if (window.location.href.includes('vPhone')) {
              return [2
              /*return*/
              ];
            }

            isClassicMode = ((_b = (_a = this.showPopupCondition) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.campaignMode) === 'CLASSIC_MODE';
            noTab = !((_c = this.showPopupCondition) === null || _c === void 0 ? void 0 : _c.hasTab);
            sensElementView({
              c_element_name: '落地页进入弹窗',
              material_ids: ["".concat(((_e = (_d = this.showPopupCondition) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.campaignPageId) || '')],
              activity_id: ((_g = (_f = this.showPopupCondition) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.campaignId) || '',
              activity_label: '投放'
            });
            $content_1 = document.getElementById('j-wp-ct');
            $btn = document.getElementById('j-wp-ct-btn');
            $img = document.getElementById('j-wp-img');

            if ($content_1) {
              $content_1.style.display = 'flex';

              if (currentItem_1.imageUrl) {
                $img.src = currentItem_1.imageUrl;
              } // 经典模式且没有Tab 显示按钮


              if (currentItem_1.button && isClassicMode && noTab) {
                $btn.innerHTML = "<span>".concat(currentItem_1.button, "</span>");
                removeClass($btn, 'hide');
              } // 弹窗配置了跳转链接后且配置了按钮，按钮点击跳转配置链接


              if (currentItem_1.imageUrl && currentItem_1.button && currentItem_1.jumpUrl) {
                $btn === null || $btn === void 0 ? void 0 : $btn.addEventListener('click', function () {
                  var _a, _b, _c, _d;

                  sensClickInitiative({
                    $element_name: '落地页进入弹窗_跳转按钮点击',
                    material_ids: ["".concat(((_b = (_a = _this.showPopupCondition) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.campaignPageId) || '')],
                    activity_id: ((_d = (_c = _this.showPopupCondition) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.campaignId) || '',
                    activity_label: '投放',
                    custom_state: '跳URL'
                  });
                  window.location.href = currentItem_1.jumpUrl;
                });
              } // 弹窗未配置了跳转链接后且配置了按钮，按钮点击跳转下单交互


              if (currentItem_1.imageUrl && currentItem_1.button && !currentItem_1.jumpUrl) {
                $btn === null || $btn === void 0 ? void 0 : $btn.addEventListener('click', function () {
                  var _a, _b, _c, _d;

                  sensClickInitiative({
                    $element_name: '落地页进入弹窗_跳转按钮点击',
                    material_ids: ["".concat(((_b = (_a = _this.showPopupCondition) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.campaignPageId) || '')],
                    activity_id: ((_d = (_c = _this.showPopupCondition) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.campaignId) || '',
                    activity_label: '投放',
                    custom_state: '拉起下单'
                  });
                  bus.emit('ChooseCourse');
                  $content_1.style.display = 'none';
                });
              } // 弹窗配置了跳转链接后，点击图片跳转配置链接


              if (currentItem_1.jumpUrl) {
                $link = $content_1.querySelector('.wp-link');
                $link.href = currentItem_1.jumpUrl;
              } // 点击关闭按钮， 隐藏弹窗


              (_h = $content_1.querySelector('.wp-close')) === null || _h === void 0 ? void 0 : _h.addEventListener('click', function () {
                $content_1.style.display = 'none';
              });
            }

            return [3
            /*break*/
            , 7];

          case 6:
            e_3 = _k.sent();
            reportError(e_3);
            return [3
            /*break*/
            , 7];

          case 7:
            return [2
            /*return*/
            ];
        }
      });
    });
  },
  setGlobalCookies: function setGlobalCookies(channel, linkId) {
    return __awaiter(this, void 0, void 0, function () {
      var e_4;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            //! 大促特殊判断, 完后删除
            if (query.fr === 'bg') {
              return [2
              /*return*/
              ];
            }

            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , buriedSetCookie({
              channelNo: (Array.isArray(channel) ? channel[0] : channel) || '',
              linkId: linkId || ''
            })];

          case 2:
            _a.sent();

            return [3
            /*break*/
            , 4];

          case 3:
            e_4 = _a.sent();
            reportError(e_4);
            return [3
            /*break*/
            , 4];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  },

  /**
   * 获取微信配置
   */
  weChatConf: function weChatConf(_a) {
    var wechatAppId = _a.wechatAppId,
        shareDesc = _a.shareDesc,
        shareName = _a.shareName,
        shareUrl = _a.shareUrl;
    return __awaiter(this, void 0, void 0, function () {
      var currLink_1;
      return __generator(this, function (_b) {
        try {
          if (!isWeChat || !shareName) {
            return [2
            /*return*/
            ];
          }

          currLink_1 = window.location.href;
          getWxConfig({
            appId: wechatAppId,
            url: currLink_1
          }).then(function (res) {
            if (res.resultCode === 200 && (window === null || window === void 0 ? void 0 : window.wx)) {
              wx.config(__assign(__assign({
                debug: false
              }, res.data), {
                jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline', 'updateAppMessageShareData', 'updateTimelineShareData', 'showMenuItems', 'hideMenuItems']
              }));
              var sharePic_1 = /^http/.test(shareUrl) ? shareUrl : "https:".concat(shareUrl); // 微信分享

              wx.ready(function () {
                wx.updateAppMessageShareData({
                  title: shareName,
                  desc: shareDesc,
                  link: currLink_1,
                  imgUrl: sharePic_1,
                  success: function success() {}
                });
                wx.updateTimelineShareData({
                  title: shareName,
                  link: currLink_1,
                  imgUrl: sharePic_1,
                  success: function success() {}
                });
              });
            }
          });
        } catch (e) {
          reportError(e);
        }

        return [2
        /*return*/
        ];
      });
    });
  },
  // 闪验jsdk

  /* shanyan() {
    const script = document.createElement('script');
    script.async = true;
    script.src = `${cdnPath}shanyan.js?t=${Date.now()}`;
    document.body.appendChild(script);
  }, */
  // vivo回传
  vivoReport: function vivoReport() {
    if (window.location.href.indexOf('BJTF_ZBTF_DHXS_NONE') >= 0) {
      var vivo = document.createElement('script');
      vivo.async = true;
      vivo.src = 'https://sspstatic.vivo.com.cn/ssp/js/vadevent.1.0.0.js';
      document.body.appendChild(vivo);
    }
  },
  // TikTok鉴权
  tiktok: function tiktok() {
    return __awaiter(this, void 0, void 0, function () {
      var href, tikTokStatus, linkId, data, e_5;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            href = window.location.href;
            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            tikTokStatus = isTikTok();

            if (!tikTokStatus || href.includes('uid=')) {
              return [2
              /*return*/
              ];
            }

            if (tikTokStatus) {
              addClass(document.body, 'tiktok');
            }

            linkId = query.linkId;

            if (!linkId) {
              return [2
              /*return*/
              ];
            }

            return [4
            /*yield*/
            , tiktokVerify({
              completeUrl: href,
              linkId: linkId
            })];

          case 2:
            data = _a.sent().data;

            if (data && data.authUrl) {
              window.location.href = data.authUrl;
            }

            return [3
            /*break*/
            , 4];

          case 3:
            e_5 = _a.sent();
            window.location.href = "".concat(href, "&uid=err");
            return [3
            /*break*/
            , 4];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  }
};

function ready(func) {
  if (document.readyState !== 'loading') {
    func();
  } else {
    document.addEventListener('DOMContentLoaded', func);
  }
}

ready(fn.init.bind(fn));